export default "__VITE_ASSET__ZUaHcTrV__"